export default {
  'missing-user': 'Informe seu usuário',
  'missing-email': 'Usuário não possui email cadastrado',
  'missing-mimic': 'Usuário não tem permissão de personificação',

  'invalid-pin': 'Pin inválido, tente novamente',
  'expired-pin': 'Este pin já foi expirado, por favor tente novamente',

  'invalid-user': 'Usuário inválido',
  'invalid-password': 'Senha inválida',
  'invalid-recover': 'Sessão invalida, requisite a recuperação novamente',
  'invalid-permission': 'Permissão inválida',
  'invalid-client': 'Serviço não registrado',
  'invalid-token': 'Token inválido',
  // eslint-disable-next-line
  'invalid-company': 'Não foi possível o acesso ao sistema. Por gentileza, entre em contato com 0800 885 0123',
  'max-attempts': 'O número de tentativas foi excedido, tente novamente em alguns minutos',
  'out-until': 'Você pode tentar novamente às',
  // eslint-disable-next-line
  // 'multiple-sessions': 'Este usuário já está autenticado em outra sessão. <a href="/session/lease">Clique aqui</a>" para liberar seu acesso via e-mail.',
  'multiple-sessions': 'Este usuário já está autenticado em outra sessão.',
  'no-lease': 'Não é possível autorizar uma nova sessão.',
  'failed': 'Houve uma falha ao processar sua requisição. Tente novamente mais tarde.',

  'ip-not-allowed': 'O seu dispositivo não está autorizado à acessar esta empresa.',

  'jwt-must-be-provided': 'Sessão inválida, requisite a recuperação novamente',
  'jwt-malformed': 'Sessão inválida',
  'jwt-expired': 'Sua sessão está expirada',
  'recover-expired': 'Este link de recuperação está expirado, solicite novamente',

  // eslint-disable-next-line max-len
  'pw-validation-error': 'Não foi possível alterar sua senha. A mesma não satisfaz o padrão de complexidade ou você a usou recentemente. Escolha outra.',
  'pw-unconfirmed': 'As senhas inseridas não conferem',
  // eslint-disable-next-line max-len
  'pw-expired': 'Sua senha expirou. Realize o processo de recuperação para gerar uma nova senha válida',
};
